/** Distinct-id coverage. Callers batch ids; the RPC never returns chunk rows. */

export const COVERAGE_BATCH_SIZE = 100;

export function isCoverageRequestAllowed(
  role: string | null | undefined,
  callerUserId: string | null | undefined,
  requestedUserId: string
): boolean {
  if (!requestedUserId.trim()) return false;
  if (role === 'service_role') return true;
  return !!callerUserId && callerUserId === requestedUserId;
}

export function coverageIdsFromRpc(data: unknown): string[] {
  if (!Array.isArray(data)) return [];
  const ids: string[] = [];
  for (const row of data) {
    if (typeof row === 'string' && row) {
      ids.push(row);
      continue;
    }
    if (row && typeof row === 'object' && 'id' in row) {
      const id = (row as { id: unknown }).id;
      if (typeof id === 'string' && id) ids.push(id);
    }
  }
  return ids;
}

export async function presenceForIds(
  ids: string[],
  fetchPresent: (batch: string[]) => Promise<string[]>,
  batchSize = COVERAGE_BATCH_SIZE
): Promise<Record<string, boolean>> {
  const result: Record<string, boolean> = {};
  for (const id of ids) result[id] = false;
  if (ids.length === 0) return result;

  for (let i = 0; i < ids.length; i += batchSize) {
    const batch = ids.slice(i, i + batchSize);
    const present = await fetchPresent(batch);
    for (const id of present) {
      if (Object.prototype.hasOwnProperty.call(result, id)) result[id] = true;
    }
  }
  return result;
}

/**
 * The old status query selected every chunk row. PostgREST stops at 1000 rows,
 * so later documents in a batch looked unembedded.
 */
export function presenceFromCappedChunkRows(
  ids: string[],
  chunkRows: Array<{ ownerId: string }>,
  rowCap: number
): Record<string, boolean> {
  const result: Record<string, boolean> = {};
  for (const id of ids) result[id] = false;
  for (const row of chunkRows.slice(0, rowCap)) {
    if (Object.prototype.hasOwnProperty.call(result, row.ownerId)) result[row.ownerId] = true;
  }
  return result;
}
